import { AUTH_REDIRECT_URI } from '../../config'

export const getRedirectUri = () => {
  const redirectUrl = new URL(window.location.pathname, AUTH_REDIRECT_URI)
  return redirectUrl.toString()
}
